export default __webpack_public_path__ + "static/media/whatsapp_icon.2e7df8b8.webp";